"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_parser_1 = require("@dynamynd/content-parser");

var responsive_1 = require("@dynamynd/responsive");

var React = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var ContentBox = function ContentBox(props) {
  var contentText = props.contentText,
      imageUri = props.imageUri,
      activeBreakpoint = props.activeBreakpoint;
  return React.createElement(ContentBoxContainer, {
    activeBreakpoint: activeBreakpoint
  }, imageUri && React.createElement(ContentImage, {
    source: {
      uri: imageUri
    },
    activeBreakpoint: activeBreakpoint,
    resizeMode: "contain"
  }), React.createElement(ContentText, {
    activeBreakpoint: activeBreakpoint
  }, React.createElement(content_parser_1.ParsedContent, {
    content: contentText
  })));
};

var ContentBoxContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return React.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    ", "\n"], ["\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var medium = responsive_1.isMedium(activeBreakpoint);
  return "\n            margin-left: " + (medium ? 70 : 40) + "px;\n            width: " + setContainerWidth(activeBreakpoint) + "px;\n        ";
});

function setContainerWidth(activeBreakpoint) {
  if (!responsive_1.isExtraLarge(activeBreakpoint)) {
    return 260;
  }

  return 350;
}

var ContentText = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return React.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
  return "\n    font-size: " + (!extraLarge ? 14 : 18) + "px;\n    line-height: " + (!extraLarge ? 24 : 32) + "px;\n    ";
});
var ContentImage = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return React.createElement(react_native_1.Image, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 auto;\n    ", "\n"], ["\n    margin: 0 auto;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
  return "\n            width: " + setImageWidth(extraLarge) + "px;\n            height: " + (!extraLarge ? 190 : 240) + "px;\n            margin-bottom: " + (!extraLarge ? 15 : 35) + "px;\n        ";
});

function setImageWidth(extraLarge) {
  if (extraLarge) {
    return 240;
  }

  return 300;
}

exports.default = responsive_1.withResponsiveMeta(ContentBox);
var templateObject_1, templateObject_2, templateObject_3;